import { setLocation } from '../LocationCardCarousel/actions';

export const mapDispatchToProps = {
    setLocation,
};
